import { memo, useMemo } from 'react';
import DayIcon from '@ubnt/icons/DayIcon';
import HomeIcon from '@ubnt/icons/HomeIcon';
import ToggleButton from 'modules/bottomPanel/components/elements/ToggleButton';
import { useApplicationStore } from 'modules/application/store';

export interface OutdoorSwitchProps {
  onClick: () => void;
  isOutdoor: boolean;
}

const OutdoorSwitch = (props: OutdoorSwitchProps) => {
  const { onClick, isOutdoor } = props;
  const isMobile = useApplicationStore((state) => state.isMobile);
  const description = useMemo(() => {
    if (isMobile) {
      return isOutdoor ? 'Switched to Outdoor Mode' : 'Switched to Indoor Mode';
    }

    return isOutdoor ? 'Click to switch to Indoor Mode' : 'Click to switch to Outdoor Mode';
  }, [isMobile, isOutdoor]);

  return (
    <ToggleButton
      onClick={onClick}
      tooltipDescription={description}
      tooltipTitle={isOutdoor ? 'Outdoor Mode' : 'Indoor Mode'}
    >
      {isOutdoor ?
        <DayIcon />
      : <HomeIcon />}
    </ToggleButton>
  );
};

const MemoizedOutdoorSwitch = memo(OutdoorSwitch);

export default MemoizedOutdoorSwitch;
